
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { NextPage } from 'next';
import { withUrql } from '@/config/graphql';
import useTranslation from 'next-translate/useTranslation';
import { useCurrentUserQuery } from '@/client/graphql/users.generated';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { REDIRECT_PATHS } from '@/config/redirect-paths';
import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { BasePageLayout } from '@/components/templates';
import { Seo } from '@/components/utils/seo/seo-component';
import { BACKEND_URLS } from '@/config/urls';
const Page: NextPage = () => {
    const { t } = useTranslation('invite');
    const [{ data }] = useCurrentUserQuery();
    const { push, query } = useRouter();
    useEffect(() => {
        if (data) {
            push(REDIRECT_PATHS.DASHBOARD);
        }
        else {
            if (query.slug) {
                const slug = query.slug as string;
                localStorage.setItem('invitecode', slug);
            }
        }
    }, [data, push, query.slug]);
    return (<BasePageLayout>
      <Seo title={t('meta.title')} description={t('meta.description')} noindex/>
      <Box position="relative" bgColor="gray.800" w="100%" maxW="460" padding={{ base: '32px 24px', md: '40px' }} margin={{ base: '0 auto', md: '12px auto 0' }} borderRadius={4}>
        <Heading as="h1" size="lg" mb={4}>
          {t('title')}
        </Heading>
        <Text mb={4}>{t(`text`)}</Text>
        <Button onClick={() => {
            push(BACKEND_URLS.REGISTER);
        }}>
          {t('common:navigation.register')}
        </Button>
      </Box>
    </BasePageLayout>);
};
const __Next_Translate__Page__1973b3b2da0__ = withUrql(Page);

    export default __appWithI18n(__Next_Translate__Page__1973b3b2da0__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
    });
  